// extracted by css-extract-rspack-plugin
export default {"tagsSection":"TagsSection-module__tagsSection__iWdfz6b","categories":"TagsSection-module__categories__XHRZvl0"};